import DOMPurify from 'dompurify';

// Helper to check if content is effectively empty
export function isQuillContentEmpty(html) {
  const clean = DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim();
  return clean === '';
}

export const modules = {
  toolbar: [
    // Font family and size
    [{ 'font': [] }, { 'size': ['small', false, 'large', 'huge'] }],

    // Headings
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    // Text styles
    ['bold', 'italic', 'underline', 'strike'],

    // Subscript / Superscript
    [{ 'script': 'sub' }, { 'script': 'super' }],

    // Blockquote and code block
    ['blockquote', 'code-block'],

    // Color and background
    [{ 'color': [] }, { 'background': [] }],

    // Text alignment and direction (RTL)
    [{ 'align': [] }, { 'direction': 'rtl' }],

    // Ordered / bullet list
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],

    // Indent and outdent
    [{ 'indent': '-1' }, { 'indent': '+1' }],

      ['link'],

    // formula 
    ['formula'],
    // Clear formatting
    ['clean'],

   
  ],
  formula: true,
};

export const formats = [
  'font', 'size',
  'header',
  'bold', 'italic', 'underline', 'strike',
  'script',
  'blockquote', 'code-block',
  'color', 'background',
  'align', 'direction',
  'list', 'bullet', 'indent',
  'link', 'image', 'video',
  'formula'
];

export const applyQuillTooltips = (quillRef) => {
  const editor = quillRef?.current?.container;
  if (!editor) return;

  const toolbar = editor.querySelector(".ql-toolbar");
  if (!toolbar) return;

  const tooltips = {
    ".ql-bold": "Bold",
    ".ql-italic": "Italic",
    ".ql-underline": "Underline",
    ".ql-strike": "Strike",
    ".ql-blockquote": "Block Quote",
    ".ql-code-block": "Code Block",
    ".ql-link": "Insert Link",
    ".ql-clean": "Clear Formatting",
    ".ql-header": "Heading",
    ".ql-font": "Font Family",
    ".ql-size": "Font Size",
    ".ql-color": "Text Color",
    ".ql-background": "Background Color",
    ".ql-align": "Align Text",
    ".ql-direction": "Text Direction",
    ".ql-list[value='ordered']": "Ordered List",
    ".ql-list[value='bullet']": "Bullet List",
    ".ql-indent[value='-1']": "Decrease Indent",
    ".ql-indent[value='+1']": "Increase Indent",
    ".ql-script[value='sub']": "Subscript",
    ".ql-script[value='super']": "Superscript"
  };

  Object.keys(tooltips).forEach((selector) => {
    const el = toolbar.querySelector(selector);
    if (el) el.setAttribute("title", tooltips[selector]);
  });
};